module.exports = __webpack_public_path__ + "42ed01c058dba17794dd03c9d368fc3c.png";